<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.book.receivedList')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
               
                <back-button/>
             <hr>


                <div class="row my-5">
                    <div class="col-10 p-0 mx-auto" style="max-width:794px;">
                                
                    <div class="text-right mr-0 mb-2">
                            <button class="btn btn-danger btn-sm" @click="generate('pdf')">
                                                <i class="fa fa-download" aria-hidden="true"></i> {{$t('button.pdf')}}
                            </button>
                                        
                            <button class="btn btn-primary btn-sm" @click="generate('word')">
                                                <i class="fa fa-download" aria-hidden="true"></i> {{$t('button.word')}}
                            </button>
                    </div>

                        <div class="card px-5 page" style="min-height:297mm; width:794px;">
                            <div class="card-body">
                                <div class="logo mt-3 mb-5">
                                    <img src='/logo/sbs_transp.png' alt="SBS Logo"
                                        style="height: 57.6px; width: 213.12px;">
                                </div>

                                <h3 class="text-bold">{{$t('form.book.list_books_received')}}</h3>
                                <h6 v-if="student.programs.length > 0" class="text-bold mb-3">{{student.programs[0].ProgramTitle+','+student.programs[0].ProgramType}}</h6>
                                
                                <p class="clr-dark ">Student: <strong>{{student.FirstName+' '+student.LastName}} {{student.StudentNumber}}</strong></p>
                              
                               
                                    <ul v-if="bookList.length">
                                     
                                      
                                            <li class="mb-4" v-for="(book, index) in bookList" v-bind:key="index">
                                                <p class="text-bold">{{book.Title}}</p>
                                                <p>{{book.Author}}</p>
                                                <p>{{book.Publisher}}</p>
                                                <p>{{book.ISBN}}</p>
                                                <div style="display:flex;">
                                                <div class="text-bold pr-1">{{$t('form.book.book_received_on')}} </div>
                                                <div style="flex-grow:1; border-bottom:2px solid black; margin-bottom:2px;"></div>    
                                                 <div class="text-bold pl-1">{{formatDate(book.pivot.TakingDate)}}</div>
                                                </div>
                                               
                                            </li>
                                        
                                    </ul>
                                    <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                               

                                <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                                    @paginate="paginateData()"></pagination>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions'],

        data() {

            return {
                isLoading: false,
                fullPage: true,

                pagination: {
                    'current_page': 1
                },

                student: {programs:[]},
                bookList: [],
                allBooks:[],
            }
        },

        mounted() {
            if (!this.permissions.viewBooksSubmissions) {
                return this.$router.push('/');
            }

            this.getBooks();
        },

        methods: {
            getBooks() {
                this.isLoading = true;

                axios
                    .get('/api/submissions/' +
                        this.$route.params.id + '?page=' +
                        this.pagination.current_page)
                    .then(response => {
                        this.isLoading = false;

                        this.student = response.data.data.data[0];
                        
                        let Books =  response.data.data.data[0].book;
                        
                        this.student.bookbundle.forEach(bundle =>
                        

                        bundle.books.forEach(book => {
                            book.pivot= {TakingDate: bundle.pivot.TS};
                            Books.push(book);
                            })
                        );
                      
                        this.bookList = Books;

                        this.pagination = response.data.pagination;

                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log(error.response);
                    });
            },    
            async createToken(type) {
                let response = await axios.post('/api/api-tokens', {
                    type
                });
                let token = '';

                if (response.status == 200) {
                    token = response.data.extra[0].token
                }

                return token;
            },
            /**
             * Export students list - PDF | Excel | Word
             */
            async generate(method) {
                let token = await this.createToken('students-export');
                if (token == '') return;
                window.open(`/submissions/export?method=${method}&student=${this.$route.params.id}&token=${token}`, "_blank");
            },
              /**
             * Format Date
             */
            formatDate(date) {
                if(date){
                    return moment(date).format('LL');
                }
                return null;
            },
        }
    }

</script>

<style scoped>
    .box {
        font-family: sans-serif;
        width: 700px;
        border: solid 1px #ccc;
        text-align: center;
        padding: 1em;
        margin: 2em auto;
        height: auto !important;
        overflow: auto;
        overflow: hidden;
        min-height: 700px;
    }

.page{
    line-height: 1 !important;
}

    @media print {
    .page {
        height: 100%;
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        bottom:0;
        right:0;
        margin: 0;
    }
    }
</style>
